import type { ApiErrorMessage } from 'epic/apiErrorEpicHelper';
import type { ProductModificationResult } from 'epic/postTradeOperations/productModification/productModificationResultEpic';
import type { ProductModificationFormResult } from 'models/forms/productModification';

import * as actionTypes from './productModificationForm.actionTypes';

export type ProductModificationFormAction =
  | ProductModificationTabCreated
  | ProductModificationFormRequestActions
  | ProductModificationFightingBackActions
  | ProductModificationApplyActions;

type ProductModificationFormRequestActions =
  | ProductModificationFormRequested
  | ProductModificationFormRequestFailed
  | ProductModificationFormRequestTimedOut
  | ProductModificationFormReceived
  | ProductModificationReloadRequested;

type ProductModificationFightingBackActions =
  | ProductModificationFightingBackCommentChanged
  | ProductModificationFightingBackJustificationChanged
  | ProductModificationPublicOfferingDisclaimerConfirmationChanged;

type ProductModificationApplyActions =
  | ProductModificationApplyRequested
  | ProductModificationApplyRequestFailed
  | ProductModificationResultReceived
  | ProductModificationResultFailed;

export type ProductModificationTabCreated = ReturnType<typeof productModificationTabCreated>;
export function productModificationTabCreated(tabId: string, productId: string, tabName: string) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_TAB_CREATED,
    tabId,
    productId,
    tabName,
  };
}

export type ProductModificationFormRequested = ReturnType<typeof productModificationFormRequested>;
export function productModificationFormRequested(tabId: string, productId: string) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_FORM_REQUESTED,
    tabId,
    productId,
  };
}

export type ProductModificationReloadRequested = ReturnType<typeof productModificationReloadRequested>;
export function productModificationReloadRequested(tabId: string, productId: string) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_RELOAD_FORM_REQUESTED,
    tabId,
    productId,
  };
}

export type ProductModificationFormReceived = ReturnType<typeof productModificationFormReceived>;
export function productModificationFormReceived(
  tabId: string,
  productId: string,
  productModificationFormResult: ProductModificationFormResult,
) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_FORM_RECEIVED,
    tabId,
    productId,
    data: productModificationFormResult,
  };
}

export function productModificationFightingBackCommentChanged(tabId: string, comment: string) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_FIGHTING_BACK_COMMENT_CHANGED,
    tabId,
    comment,
  };
}
export type ProductModificationFightingBackCommentChanged = ReturnType<
  typeof productModificationFightingBackCommentChanged
>;

export function productModificationPublicOfferingDisclaimerConfirmationChanged(tabId: string, hasConfirmed: boolean) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_PUBLIC_OFFERING_DISCLAIMER_CONFORMATION_CHANGED,
    tabId,
    hasConfirmed,
  };
}
export type ProductModificationPublicOfferingDisclaimerConfirmationChanged = ReturnType<
  typeof productModificationPublicOfferingDisclaimerConfirmationChanged
>;

export function productModificationFightingBackJustificationChanged(tabId: string, justification: string) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_FIGHTING_BACK_JUSTIFICATION_CHANGED,
    tabId,
    justification,
  };
}
export type ProductModificationFightingBackJustificationChanged = ReturnType<
  typeof productModificationFightingBackJustificationChanged
>;

export type ProductModificationFormRequestFailed = ReturnType<typeof productModificationFormRequestFailed>;

export function productModificationFormRequestFailed(tabId: string, productId: string, error: string) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_FORM_REQUEST_FAILED,
    tabId,
    productId,
    error,
  };
}

export type ProductModificationFormRequestTimedOut = ReturnType<typeof productModificationFormRequestTimedOut>;

export function productModificationFormRequestTimedOut(tabId: string, productId: string) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_FORM_REQUEST_TIMED_OUT,
    tabId,
    productId,
  };
}

export function productModificationApplyRequested(
  tabId: string,
  requestId: string,
  startingTimeInMillis: number,
  durationInMillis: number,
) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_APPLY_REQUESTED,
    tabId,
    requestId,
    startingTimeInMillis,
    durationInMillis,
  };
}
export type ProductModificationApplyRequested = ReturnType<typeof productModificationApplyRequested>;

export function productModificationResultReceived(tabId: string, productModificationResult: ProductModificationResult) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_RESULT_RECEIVED,
    tabId,
    productModificationResult,
  };
}

export type ProductModificationApplyRequestFailed = ReturnType<typeof productModificationApplyRequestFailed>;

export function productModificationApplyRequestFailed(
  tabId: string,
  requestId: string,
  technicalError: ApiErrorMessage,
  cause: any,
) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_APPLY_REQUEST_FAILED,
    tabId,
    requestId,
    technicalError,
    cause,
  };
}

export type ProductModificationResultReceived = ReturnType<typeof productModificationResultReceived>;

export function productModificationResultFailed(tabId: string, technicalError: ApiErrorMessage, cause: any) {
  return {
    type: actionTypes.PRODUCT_MODIFICATION_RESULT_FAILED,
    tabId,
    technicalError,
    cause,
  };
}
export type ProductModificationResultFailed = ReturnType<typeof productModificationResultFailed>;
